<template>
  <div id="app" :class="{'noScroll': disabled}" class="h-full">
    <Menu @scrollBody="stopScrollBody"/>
    <router-view @scrollBody="stopScrollBody"/>
  </div>
</template>

<script>
import './assets/css/styles.css'
import Menu from '@/components/Menu.vue'
export default {
  name: 'app',
  data () {
    return {
      disabled: false
    }
  },
  methods: {
    stopScrollBody () {
      this.disabled = !this.disabled
    }
  },
  components: {
    Menu
  }
}
</script>

 <style lang="scss">
 .noScroll {
    overflow: hidden;
    height: 100vh;
}
</style>
